// react
import { useEffect, useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { ActionButton, LoadingStatus, TransactionType } from '../../../@types';

// dialogs
import { DialogActions, DialogActionsProps } from '../DialogActions/DialogActions';

// forms
import { FormAddTransaction } from '../../forms/FormAddTransaction/FormAddTransaction';

// props
export interface DialogAddTransactionProps {
	DialogActionsProps?: Partial<DialogActionsProps>;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
	type?: TransactionType;
}

export const DialogAddTransaction = ({
	DialogActionsProps = {},
	isOpen,
	onClose,
	onSuccess,
	type,
}: DialogAddTransactionProps) => {
	const { t } = useTranslation();

	// state
	const [status, setStatus] = useState<LoadingStatus>('DEFAULT');

	DialogActionsProps.actions = [];

	if (['DEFAULT', 'ERROR'].includes(status)) {
		DialogActionsProps.actions.push({
			children: t('cancel'),
			onClick: onClose,
		});
	}

	DialogActionsProps.title = {
		children: t('recordPayment'),
		variant: 'h3',
	};

	const actionSubmit: ActionButton = {
		children: t('recordPayment'),
		form: 'form-add-payment',
		loading: status === 'LOADING',
		type: 'submit',
		variant: 'contained',
	};

	if (type === 'CASH_BENEFIT') {
		actionSubmit.children = t('recordCashBenefit');

		if (DialogActionsProps.title) {
			DialogActionsProps.title.children = t('recordCashBenefit');
		}
	}

	if (type === 'OPEX') {
		actionSubmit.children = t('recordOpEx');

		if (DialogActionsProps.title) {
			DialogActionsProps.title.children = t('recordOpEx');
		}
	}

	if (DialogActionsProps.actions) {
		DialogActionsProps.actions.push(actionSubmit);
	}

	if (status === 'SUCCESS') {
		DialogActionsProps.actions = [
			{
				children: t('done'),
				onClick: onClose,
				variant: 'contained',
			},
		];
	}

	// reset status when dialog is closed
	useEffect(() => {
		if (!isOpen) {
			setStatus('DEFAULT');
		}
	}, [isOpen]);

	return (
		<DialogActions
			hasClose={true}
			isOpen={isOpen}
			maxWidth={570}
			onClose={onClose}
			{...DialogActionsProps}>
			<FormAddTransaction onSuccess={onSuccess} setStatus={setStatus} status={status} type={type} />
		</DialogActions>
	);
};
